var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiStars = function SvgAiStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D276CE",
    d: "m8.51 15.645 1.554 2.288 2.288 1.555-2.288 1.554-1.555 2.289-1.554-2.289-2.289-1.554 2.289-1.555 1.554-2.288Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3A8F0",
    d: "m16.744 4.664 1.78 4.809 4.809 1.78-4.81 1.779-1.779 4.809-1.779-4.81-4.809-1.779 4.81-1.78 1.778-4.808Z"
  })));
};
export default SvgAiStars;